import i18n from "config/i18next";

i18n.addResources("es", "benefits", {
  title: "Beneficios",
  packageCardTitle: "Pedidos listos",
  packageCardText:
    "Los paquetes ya están preparados para que los busques. ¡No los tenés que esperar!",
  freeTimeCardTitle: "Finde libre",
  freeTimeCardText:
    "Repartos disponibles de lunes a viernes, por la mañana y la tarde.",
  cashCardTitle: "Libre de efectivo",
  cashCardText:
    "En tus repartos no vas a cobrar ni a pagar nada, solo llevar el paquete a destino.",
  supportCardTitle: "Atención personalizada",
  supportCardText:
    "Contamos con un equipo de soporte atento a tus necesidades.",
});
